import ApiService from "@/core/services/api.service";
import ImageUploadChunkService from "@/modules/core/services/file/image/image_upload_chunk.service";

export default {
  /**
   * Attempts to uploadd Staff Image
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  async uploadStaffImage(context, payload) {
    ApiService.setHeader();

    try {
      const chunks = ImageUploadChunkService.generateChunks(payload.image);
      console.log("Chunks", chunks);

      let counter = 0;
      let response;
      const fileName = require("crypto").randomBytes(64).toString("hex");

      for (const chunk of chunks) {
        let formData = new FormData();

        formData.set(
          "is_last",
          counter === chunks.length - 1 ? "true" : "false"
        );
        formData.set("image", chunk, `${fileName}.part`);
        formData.append("id", payload.id);

        response = await ApiService.post(
          "school/employee/staff/image",
          formData,
          ImageUploadChunkService.getConfig()
        );

        counter++;
      }

      context.commit("setUploadEmployeeImage", response.data.url);
      return response;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};
